// extracted by mini-css-extract-plugin
export default {"products":"rx-z","card":"sx-z","oosMessaging":"tx-z"};